import { Box, Divider, Skeleton, TableCell, TableRow } from "@material-ui/core";

const TableRowsLoaderVariant = ({ rowsNum, height,hasDivider }) => {
	return <>
		{
			[...Array(rowsNum)].map(() => (
				<>
					<Box ><Skeleton animation="wave" variant="rectangular" height={height}  sx={{mt:2}}/></Box>
					{hasDivider?(<><Divider/></>):<></>}
					
				</>
			))
		}
	</>
};

export default TableRowsLoaderVariant;